import { Spinner, Text, tokens } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import { getPageBlob } from "@/api/documents";

export function PageImage({
  documentId,
  pageName,
  rotation = 0,
}: {
  documentId: string;
  pageName: string;
  rotation?: number;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setUrl(null);
    setError(null);
    getPageBlob(documentId, pageName)
      .then((u) => {
        if (active) setUrl(u);
      })
      .catch((e) => {
        if (active) setError(e instanceof Error ? e.message : "Load failed");
      });
    return () => {
      active = false;
    };
  }, [documentId, pageName]);

  if (error) {
    return (
      <div style={{ padding: 24, color: tokens.colorPaletteRedForeground1 }}>
        <Text>Failed to load page: {error}</Text>
      </div>
    );
  }
  if (!url) {
    return (
      <div style={{ padding: 48, display: "flex", justifyContent: "center" }}>
        <Spinner label={`Loading ${pageName}…`} />
      </div>
    );
  }
  return (
    <TransformWrapper
      minScale={0.5}
      maxScale={5}
      initialScale={1}
      doubleClick={{ mode: "toggle", step: 1.5 }}
      wheel={{ step: 0.2 }}
    >
      <TransformComponent
        wrapperStyle={{ width: "100%", height: "100%" }}
        contentStyle={{ width: "100%", height: "100%" }}
      >
        <img
          src={url}
          alt={pageName}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            display: "block",
            margin: "0 auto",
            objectFit: "contain",
            transform: `rotate(${rotation}deg)`,
            transformOrigin: "center center",
            transition: "transform 150ms ease",
          }}
        />
      </TransformComponent>
    </TransformWrapper>
  );
}
